import script from "./pc-module-table-3.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-table-3.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-table-3.vue?vue&type=style&index=0&id=7631ae34&lang=scss"

const __exports__ = script;

export default __exports__